export default () => ({
  root: {
    margin: '0 auto',
    padding: '0',
    overflow: 'hidden',
    minHeight: '100vh',
    position: 'relative'
  }
});
